export default {
    container: {
        position: "relative",
    },

    dropdownOptionsContainer: {
        position: "absolute",
        top: "100%",
        left: "0",
        zIndex: "99",
        display: "block",
        backgroundColor: "#FFF",
        border: "0.5px solid #B3B3B3",
        borderRadius: "6px",
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.05)",
        padding: "0px 20px",
        marginTop: "5px"
    },

    checkBoxContainer: {
        padding: "15px 0px",
        borderBottom: "0.5px solid #BEBEBE",
    },

    scrollableBody: {
        maxHeight: "300px",
        overflowY: "overlay",
    },
    selectAllAndSearchContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "5px",
        alignItems: "center",
    },
    customInputContainerStyles: {
        marginTop: "7px",
        border: "1px solid #ccc",
        borderRadius: "10px",

    },
    searchInputContainer: {
        width: "100%",
    }
}